/*
  StarLux — required product option validation feedback.

  Horizon's AddToCartComponent.handleClick() does:
      if (!form?.checkValidity()) return;
  i.e. it aborts silently when a required option (Color / Pattern, Heading Style, ...)
  has not been selected. The shopper sees absolutely nothing happen.

  This script adds the missing feedback: it blocks the click, highlights the first
  unselected option, scrolls to it and shows an inline message under the button.
  It never interferes when the form is valid.
*/
(function () {
  var FALLBACK = 'Please select all required options before adding to cart.';

  var style = document.createElement('style');
  style.textContent =
    '[data-starlux-invalid]{outline:2px solid #C0392B;outline-offset:2px;border-color:#C0392B;}' +
    '.starlux-option-error{color:#C0392B;font-size:0.9rem;line-height:1.4;margin-top:0.5rem;display:block;}';
  document.head.appendChild(style);

  function labelFor(field) {
    if (!field) return '';
    var text = '';
    if (field.id) {
      var escaped = window.CSS && CSS.escape ? CSS.escape(field.id) : field.id;
      var byFor = document.querySelector('label[for="' + escaped + '"]');
      if (byFor) text = byFor.textContent || '';
    }
    if (!text) {
      var wrap = field.closest ? field.closest('div') : null;
      var nearby = wrap ? wrap.querySelector('label, legend') : null;
      if (nearby) text = nearby.textContent || '';
    }
    if (!text) {
      var name = field.getAttribute('name') || '';
      var match = name.match(/\[([^\]]+)\]/);
      if (match) text = match[1];
    }
    return text.replace(/\s+/g, ' ').trim();
  }

  function firstInvalid(form) {
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el && el.willValidate && typeof el.checkValidity === 'function' && !el.checkValidity()) return el;
    }
    return null;
  }

  function showError(form, field) {
    var label = labelFor(field);
    var message = label ? 'Please select ' + label + ' before adding to cart.' : FALLBACK;

    var holder = (form.closest && form.closest('product-form-component')) || form;
    var box = holder.querySelector('.starlux-option-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'starlux-option-error';
      box.setAttribute('role', 'alert');
      var anchor = holder.querySelector('add-to-cart-component') || form;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
      else holder.appendChild(box);
    }
    box.textContent = message;
    box.style.display = 'block';

    if (!field) return;

    field.setAttribute('data-starlux-invalid', 'true');
    var clear = function () {
      field.removeAttribute('data-starlux-invalid');
      box.style.display = 'none';
      field.removeEventListener('change', clear);
    };
    field.addEventListener('change', clear);

    try {
      field.focus({ preventScroll: true });
    } catch (e) {
      try { field.focus(); } catch (e2) {}
    }
    if (field.scrollIntoView) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('button');
      if (!button) return;

      var isAddToCart = !!button.closest('add-to-cart-component') || button.name === 'add';
      var isDynamicCheckout = !!button.closest('.shopify-payment-button');
      if (!isAddToCart && !isDynamicCheckout) return;

      var form = button.form || (button.closest ? button.closest('form') : null);
      if (!form) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      if (typeof form.checkValidity !== 'function') return;
      if (form.checkValidity()) return;

      event.preventDefault();
      event.stopPropagation();
      showError(form, firstInvalid(form));
    },
    true
  );
})();
